import { render, staticRenderFns } from "./pointsExchangeDetail.vue?vue&type=template&id=871e1a8a&scoped=true"
import script from "./pointsExchangeDetail.vue?vue&type=script&lang=js"
export * from "./pointsExchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./pointsExchangeDetail.vue?vue&type=style&index=0&id=871e1a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e1a8a",
  null
  
)

export default component.exports